<template>
    <div class="your-vehicle bg-white d-flex">
        <div class="col">
            <div class="d-block d-sm-inline-block">
                <b class="d-none d-sm-inline-block fs-5 text-navy">Your Vehicle</b>
            </div>
            <span class="d-none d-lg-inline-block mx-3"> - </span>
            <div class="d-block d-sm-inline-block">
                    <p class="d-inline-block mb-1 ms-0 ms-lg-2">Registration:</p>
                    <p class="reg-input d-inline-block mb-1">{{ registration }}</p>
                    <template v-if="make || model">
                        <p class="d-inline-block ms-0 ms-sm-3 mb-1">Model: <b class="d-inline-block">{{ make }} {{  model }}</b></p>
                    </template>
                    <div class="d-inline-block cursor-pointer" @click="toggleForm = !toggleForm">
                        <i class="fa-solid fa-pen-to-square ms-0 ms-md-3 me-2 cursor-pointer"></i>
                        <p class="d-inline-block mb-1 text-underline">Change vehicle/tyre size</p>
                    </div>
            </div>
            <slimline-reg-size-form
                class="mb-3"
                v-if="toggleForm"
                :postcode="postcode"
                :options="sizeOptions"
                custom-title="Change your vehicle or tyre size"
                :image-base-path="imageBasePath"
            ></slimline-reg-size-form>
            <hr class="my-2">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['registration', 'make', 'model', 'postcode', 'sizeOptions', 'imageBasePath'],
        data() {
	        return {
                vehicleRegistration: this.registration,
                vehicleMake: this.make,
                vehicleModel: this.model,
                toggleForm: false
	        }
	    },
	    mounted() {
            let vm = this;
            // if no props, do axios request
            if(vm.registration == null || vm.make == null || vm.model) {
                axios.get('/ajax/get_vehicle').then(function(response) {
                    vm.vehicleRegistration = response.data.registration
                    vm.vehicleMake = response.data.make
                    vm.vehicleModel = response.data.model
                });
            }
	    },
	    methods: {
            async updateRegistration() {
                this.emitter.emit('isLoading', true);
                let response = await axios.post('/update-registration', {registration: this.vehicleRegistration});

                console.log(response);
                this.emitter.emit('isLoading', false);
            }
	    },
	    computed: {
           
	    }
    }
</script>

<style lang="scss" scoped>
    .your-vehicle {
        .reg-input {
            border: 0;
            padding: 5px 0;
            border-radius: 6px;
            background-color: #fc3 !important;
            text-align: center;
            color: black;
            font-weight: bold;
            font-size: 16px;
            text-transform: uppercase;
            margin-left: 10px;
            width: 110px;
            &::placeholder {
                color: #383838;
            }
        }
    }
</style>